import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';

import HeadingActions from '../../components/HeadingActions';

export const PageLinks = props => {
  const getEditPath = () => {
    if (props.isCustom) {
      return `/custom-service-request/${props.partyId}/${props.serviceRequestId}`;
    } else {
      return `/service-request/${props.partyId}/${props.serviceRequestId}`;
    }
  };

  return (
    <HeadingActions
      isDirty={props.isDirty}
      key={ShortId.generate()}
      isTransportation={props.isTransportation}
      showPath={`/request-information/${props.serviceRequestId}`}
      editPath={getEditPath()}
      historyPath={`/request-information-history/${props.serviceRequestId}`}
      transportationPath={`/service-request/${props.partyId}/${props.serviceRequestId}/transportation`}
      changeHistoryPath={`/service-request/${props.partyId}/${props.serviceRequestId}/change-history`}
      discussion={{
        ...props.discussion,
        iconOnly: true,
        serviceRequestId: props.serviceRequestId
      }}
    />
  );
};

PageLinks.propTypes = {
  isCustom: PropTypes.bool,
  isDirty: PropTypes.bool,
  partyId: PropTypes.string,
  serviceRequestId: PropTypes.string,
  discussion: PropTypes.object,
  isTransportation: PropTypes.bool
};
